"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_service_1 = require("../../shared/service/http.service");
var jira_ticket_1 = require("../model/jira-ticket");
var find_http_error_1 = require("../../shared/error/find-http-error");
var Subject_1 = require("rxjs/Subject");
var JiraTicketService = /** @class */ (function () {
    function JiraTicketService(_httpService) {
        this._httpService = _httpService;
        this.JIRA_TICKET_END_POINT = '/integration/jira/findJiraIssue';
        this.findSubject = new Subject_1.Subject();
        this.find$ = this.findSubject.asObservable();
        this.errorSubject = new Subject_1.Subject();
        this.error$ = this.errorSubject.asObservable();
    }
    JiraTicketService.prototype.findJiraTicket = function (typedValue) {
        var _this = this;
        this._httpService.get(this.JIRA_TICKET_END_POINT + "/" + typedValue, jira_ticket_1.JiraTicket, find_http_error_1.FindHttpError)
            .subscribe(function (ticket) { return _this.findSubject.next(ticket); }, function (error) {
            error.text = 'Não foi possível recuperar os dados desse ticket!';
            _this.errorSubject.next(error);
        });
    };
    JiraTicketService.ctorParameters = function () { return [{ type: http_service_1.HttpService }]; };
    return JiraTicketService;
}());
exports.JiraTicketService = JiraTicketService;
//# sourceMappingURL=jira-ticket.service.js.map


// WEBPACK FOOTER //
// jira-ticket.service.js